@if (isLoading()) {
  <div class="flex items-center justify-center min-h-[60vh]">
    <div class="flex flex-col items-center gap-5">
      <div class="relative w-12 h-12">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
      <p class="text-stone-600 font-medium text-sm">Chargement…</p>
    </div>
  </div>
}

@if (!isLoading()) {

  @if (errorMessage()) {
    <div class="max-w-3xl mx-auto px-5 py-8">
      <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    </div>
  }

  @if (actualite()) {
    <div class="fiche-container animate-fade-in">

      <!-- Header -->
      <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 md:pt-8 px-2 md:px-4">
        <div class="justify-self-start">
          <button (click)="onBack()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux actualités</span>
          </button>
        </div>
        <div class="justify-self-center">
          <h1 class="page-title">Aperçu de l'article</h1>
        </div>
        <div class="justify-self-end flex items-center gap-2">
          @if (permService.can('marketing', 'actualites', 'status')) {
            @if ((actualite()!.news_status || 'ACTI') !== 'ACTI') {
              <button (click)="confirmStatus('ACTI')" [disabled]="isSaving()"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-emerald-200 text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors disabled:opacity-50">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                Publier
              </button>
            }
            @if ((actualite()!.news_status || 'ACTI') === 'ACTI') {
              <button (click)="confirmStatus('INAC')" [disabled]="isSaving()"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors disabled:opacity-50">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                </svg>
                Désactiver
              </button>
            }
          }
          @if (permService.can('marketing', 'actualites', 'edit')) {
            <button (click)="onEdit()" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-stone-200 text-stone-600 bg-white hover:bg-stone-50 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />
              </svg>
              Modifier
            </button>
          }
          @if (permService.can('marketing', 'actualites', 'delete')) {
            <button (click)="confirmDelete()" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-red-200 text-red-600 bg-white hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
              </svg>
              Supprimer
            </button>
          }
        </div>
      </div>

      <div class="fiche-content-area space-y-6">

        <!-- Photo -->
        <div class="border border-stone-200 bg-white rounded-2xl shadow-sm overflow-hidden">
          @if (actualite()!.file_link) {
            <div class="w-full aspect-[16/9] rounded-t-2xl overflow-hidden bg-stone-100 relative flex items-center justify-center">
              <img [src]="actualite()!.file_link" aria-hidden="true"
                class="absolute inset-0 w-full h-full object-cover blur-xl scale-110 opacity-70" />
              <img [src]="actualite()!.file_link" [alt]="actualite()!.news_name"
                class="relative z-10 w-full h-full object-contain" />
            </div>
          } @else {
            <div class="w-full aspect-[16/9] rounded-t-2xl bg-gradient-to-br from-stone-100 to-stone-200 flex flex-col items-center justify-center gap-2 text-stone-400">
              <svg class="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
              </svg>
              <span class="text-xs font-medium">Aucune image</span>
            </div>
          }

          <!-- Title + Meta -->
          <div class="p-6 space-y-3 border-b border-stone-100">
            <h2 [attr.dir]="dir(actualite()!.news_name)"
              class="text-lg font-semibold text-stone-900 leading-snug">
              {{ actualite()!.news_name }}
            </h2>
            <div class="flex flex-wrap items-center gap-3 text-xs text-stone-500">
              @if (actualite()!.news_begin_date) {
                <span class="flex items-center gap-1">
                  <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                  </svg>
                  {{ actualite()!.news_begin_date | date:'dd/MM/yyyy' }}
                </span>
              }
              @if (actualite()!.news_author) {
                <span [attr.dir]="dir(actualite()!.news_author!)" class="flex items-center gap-1">
                  <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                  </svg>
                  {{ actualite()!.news_author }}
                </span>
              }
              <app-tag-chips [value]="actualite()!.news_tags" [max]="999"></app-tag-chips>
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-medium"
                [class]="statusBadgeClass(actualite()!.news_status)">
                <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                  [class]="actualite()!.news_status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                {{ actualite()!.news_status_label || statusLabel(actualite()!.news_status) }}
              </span>
            </div>
            @if (actualite()!.news_excerpt) {
              <p [attr.dir]="dir(actualite()!.news_excerpt!)"
                class="text-sm text-stone-600 italic border-l-2 border-stone-200 pl-4 leading-relaxed">
                {{ actualite()!.news_excerpt }}
              </p>
            }
          </div>
        </div>

        <!-- Content -->
        <div class="fiche-section">
          <div class="fiche-section-title">Contenu</div>
          <div class="fiche-section-box p-5">
            <div
              [attr.dir]="dir(actualite()!.news_content)"
              [innerHTML]="safeContent()"
              class="article-content text-sm text-stone-700 leading-relaxed"
            ></div>
          </div>
        </div>

      </div>
    </div>
  }
}

<!-- Status confirm modal -->
@if (pendingStatus()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-50' : 'bg-emerald-50'">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            [class]="pendingStatus()!.status === 'INAC' ? 'text-amber-500' : 'text-emerald-500'">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmer le changement</p>
          <p class="text-xs text-stone-500 mt-0.5">
            @if (pendingStatus()!.status === 'INAC') { Cet article sera masqué. }
            @else { Cet article sera publié. }
          </p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelStatus()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyStatus()"
          class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'">
          {{ pendingStatusLabel(pendingStatus()!.status) }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Delete confirm modal -->
@if (pendingDelete()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Supprimer cet article</p>
          <p class="text-xs text-stone-500 mt-0.5">Cette action est irréversible.</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelDelete()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyDelete()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors">
          Supprimer
        </button>
      </div>
    </div>
  </div>
}
